<template>
  <div class="s-review-skeleton">
    <PSkeleton class="s-review-skeleton__score" height="16px" width="120px" />
    <PSkeleton height="20px" width="330px" />
    <div class="s-review-skeleton__description">
      <PSkeleton height="16px" style="width: 95%" />
      <PSkeleton height="16px" />
      <PSkeleton height="16px" style="width: 94%" />
      <PSkeleton height="16px" style="width: 70%" />
    </div>
    <PSkeleton height="16px" style="width: 75%" />
    <PSkeleton height="14px" width="300px" />
  </div>
</template>

<script setup lang="ts">
import PSkeleton from "@/atoms/PSkeleton.vue";
</script>

<style scoped lang="postcss">
.s-review-skeleton {
  @apply flex flex-col gap-4;
  &__score {
    @apply mb-2;
  }
  &__description {
    @apply flex flex-col gap-2;
  }
}
</style>
